import $ from 'jquery';
import { Component } from 'react';
import { Bloodhound, loadjQueryPlugin } from 'corejs-typeahead/index.js';
import Handlebars from 'handlebars';
loadjQueryPlugin();

class Select extends Component {
  componentDidMount() {
    let data = this.searchData();
    let options = new Bloodhound({
      datumTokenizer: function (d) {
        return Bloodhound.tokenizers.nonword(d.text);
      },
      queryTokenizer: Bloodhound.tokenizers.nonword,
      local: data,
    });
    let $input = $(`#${this.props.id}`);
    let suggestion = this.suggestion();
    $input.typeahead(
      {
        hint: true,
        highlight: true,
        minLength: 1,
      },
      {
        name: 'employees',
        source: options,
        displayKey: 'text',
        limit: 20,
        valueKey: 'id',
        templates: {
          suggestion: suggestion,
        },
      },
    );
    $input.on('typeahead:select', this.props.handler);
  }

  suggestion() {
    return Handlebars.compile(
      '<div><strong><span data=notranslate>{{text}} {{status}}</span></strong><br><span class="tt-team-name">Team - <span data-notranslate>{{team}}</span></span></div>',
    );
  }

  searchData() {
    let data = this.props.data;
    return Object.keys(data).map(function (key) {
      return {
        id: key,
        text: data[key].text,
        team: data[key].team,
        status: data[key].deactivated ? '(deactivated)' : '',
        'data-notranslate': true,
      };
    });
  }

  render() {
    let selected = this.props.selected.filter_label;
    let data = this.props.data;
    return (
      <input
        className="form-control"
        placeholder={selected}
        id={this.props.id}
        data-notranslate
      />
    );
  }
}

export default Select;
